export default __webpack_public_path__ + "static/media/MF.49693a5f.svg";